<template>
    <vx-input-group ref="group">
        <vx-input
            ref="input"
            v-model="localValue"
            v-bind="$attrs"
            v-on="$listeners"
            :label="label"
            :placeholder="placeholder"
            :disabled="disabled"
            :label-placeholder="labelPlaceholder"
            :name="name"
            :danger="danger"
            :class="[{ active: focused }, { 'remove-right-border': !!unitOptions }]"
            @focus.prevent="inputFocused"
            @blur.prevent="inputBlurred"
        />
        <template v-if="unitOptions" slot="append">
            <div
                style="padding-bottom: 19px"
                class="append-text btn-addon self-end"
                :class="{ 'invisible-label': hasLabel }"
            >
                <div
                    v-if="staticUnit"
                    class="append-text fix-margin fix-height bg-primary static-unit"
                    :class="[{ active: focused }, { 'cursor-pointer': !disabled }]"
                    @click="staticLabelClicked"
                >
                    <span v-html="staticUnit"> </span>
                </div>
                <vx-select
                    v-else
                    :disabled="disabled"
                    ref="selector"
                    v-model="localUnit"
                    class="unit-select"
                    :class="[{ active: focused, danger: danger }]"
                    :options="unitOptions"
                    :danger="danger"
                    @focus.prevent="selectFocused"
                    @blur.prevent="selectBlurred"
                    @input="unitSelected"
                ></vx-select>
            </div>
        </template>
    </vx-input-group>
</template>

<script>
export default {
    name: 'vx-unit-input',
    props: {
        value: {
            type: [Number, String]
        },
        label: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String
        },
        labelPlaceholder: {
            type: String
        },
        name: {
            type: String
        },
        unitOptions: {
            type: [Array, String]
        },
        unit: {
            type: String
        },
        danger: {
            type: Boolean
        }
    },
    watch: {
        focused(val) {
            this.$emit(val ? 'focus' : 'blur')
        }
    },
    data() {
        return {
            selectHasFocus: false,
            inputHasFocus: false
        }
    },
    computed: {
        hasLabel() {
            return this.label || this.labelPlaceholder
        },
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        localUnit: {
            get() {
                return this.unit
            },
            set(val) {
                this.$emit('update:unit', val)
            }
        },
        focused: {
            get() {
                return this.inputHasFocus || this.selectHasFocus
            },
            set(val) {
                this.inputHasFocus = val
                this.selectHasFocus = val
            }
        },
        staticUnit() {
            if (Array.isArray(this.unitOptions)) {
                if (this.unitOptions.length === 1) {
                    return this.unitOptions[0]
                }
                return null
            }
            return this.unitOptions
        },
        input() {
            return this.$refs.input
        },
        select() {
            return this.$refs.selector
        }
    },
    methods: {
        staticLabelClicked() {
            this.input.$el.focus()
        },
        inputBlurred(e) {
            this.inputHasFocus = false
            this.$emit('inputBlurred', e)
        },
        inputFocused(e) {
            if (!this.staticUnit && this.select) {
                this.select.closeMenu()
            }
            this.inputHasFocus = true
            this.selectHasFocus = false
            this.$emit('inputFocused', e)
        },
        selectBlurred(e) {
            if (e.relatedTarget ? !e.relatedTarget.closest('.vs-select--options') : false) {
                this.selectHasFocus = false
                this.$emit('selectBlurred')
            }
        },
        unitSelected(e) {
            this.selectHasFocus = false
            this.$emit('selectBlurred')
        },
        selectFocused(e) {
            this.selectHasFocus = true
            this.inputHasFocus = false
            this.$emit('selectFocused', e)
        }
    }
}
</script>

<style>
.vs-select--options {
    border-top-left-radius: 0px;
    border: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>

<style scoped>
.append-text {
    width: 70px;
    transition: all 0.3s ease;
}
.vs-input.remove-right-border ::v-deep input {
    border-right: none !important;
}
.vs-input.active ::v-deep label {
    color: rgba(var(--vs-primary), 1);
}
.vs-input ::v-deep .input-icon-validate {
    display: none;
}
.vs-input.active ::v-deep input {
    border-right: none !important;
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.vs-input.active ::v-deep i {
    color: rgba(var(--vs-primary), 1);
}
.static-unit {
    margin-top: 0px !important;
    line-height: 40px;
    padding-left: 10px !important;
    padding-right: 0px;
    letter-spacing: normal;
    font-family: system-ui;
    background-color: rgba(var(--vs-primary), 0.5) !important;
    user-select: none;
}
.static-unit.active {
    background-color: rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.unit-select {
    font-family: Montserrat, Helvetica, Arial, sans-serif;
}
.unit-select.danger ::v-deep input {
    border: 1px solid rgba(var(--vs-danger), 1);
    border-left: none;
}
.unit-select ::v-deep input {
    background-color: rgba(var(--vs-primary), 0.5);
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border: none;
    height: 37.59px;
}
.unit-select.active ::v-deep input {
    background-color: rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.unit-select ::v-deep i {
    color: white !important;
}
.fix-height {
    height: 37.59px;
    line-height: 37.59px;
}
</style>
